import React, {useEffect, useState} from "react";
import {useRouteMatch} from "react-router-dom";
import {loadEmpowermentV2Async} from "../../../../app/store/reducers/roaming/roamingEmpowermentV2Reducer";
import EmpowermentV2 from "../../../../components/hippo/roaming/empowerementV2/EmpowermentV2";
import {useDispatch, useSelector} from "react-redux";
import {selectActiveOrganization} from "../../../../app/store/reducers/auth/authReducer";
import EventBus from "../../../../app/eventbus/EventBus";
import {
    CUSTOMER_CANCEL_EMPOWERMENT_V2_SUCCESS,
    EXECUTOR_ACCEPT_EMPOWERMENT_V2_SUCCESS,
    EXECUTOR_DECLINE_EMPOWERMENT_V2_SUCCESS,
    PERSON_ACCEPT_EMPOWERMENT_V2_SUCCESS,
    PERSON_DECLINE_EMPOWERMENT_V2_SUCCESS,
    SYNC_EMPOWERMENT_V2_SUCCESS
} from "../../../../app/eventbus/roaming/roamingEmpowermentV2Events";
import {getOrganizationBillingInfoAsync} from "../../../../app/store/reducers/billing/billingReducer";
import {selectAccountRolePermissions} from "../../../../app/store/reducers/role/roleReducer";
import checkPermission from "../../../../enum/Permission/CheckPermission";
import {PermissionRoamingEmpowermentView} from "../../../../enum/Permission/RoamingPermission";
import {useHistory} from "react-router";
import SpinnerComponent from "../../../../components/hippo/spinner/SpinnerComponent";

const ViewEmpowermentV2 = ({modalId}) => {
    const {params: {id}} = useRouteMatch();
    const activeOrganization = useSelector(selectActiveOrganization);
    const dispatch = useDispatch()
    const history = useHistory();
    const permission = useSelector(selectAccountRolePermissions)

    const [empowermentV2, setEmpowermentV2] = useState(null);


    useEffect(() => {
        if ( permission.length && !dispatch(checkPermission(PermissionRoamingEmpowermentView))) {
            if (history.length > 1) {
                history.push('/roaming/empowerments-v2/inbox')
            } else {
                history.push('/')
            }
        }
    }, [permission])
    const loadEmpowermentV2 = () => {
        loadEmpowermentV2Async(modalId ? modalId : id)
            .then(loadedEmpowermentV2 => {
                setEmpowermentV2(loadedEmpowermentV2)
            })
            .catch(errors => console.log(errors))
    };

    useEffect(() => {
        loadEmpowermentV2()
    }, [modalId, id, activeOrganization]);

    useEffect(() => {
        const onCustomerCancelEmpowermentV2SuccessHandler = EventBus.on(CUSTOMER_CANCEL_EMPOWERMENT_V2_SUCCESS, () => {
            loadEmpowermentV2();
        })

        const onPersonAcceptEmpowermentV2SuccessHandler = EventBus.on(PERSON_ACCEPT_EMPOWERMENT_V2_SUCCESS, () => {
            dispatch(getOrganizationBillingInfoAsync());
            loadEmpowermentV2();
        })

        const onPersonDeclineEmpowermentV2SuccessHandler = EventBus.on(PERSON_DECLINE_EMPOWERMENT_V2_SUCCESS, () => {
            loadEmpowermentV2();
        })

        const onExecutorAcceptEmpowermentV2SuccessHandler = EventBus.on(EXECUTOR_ACCEPT_EMPOWERMENT_V2_SUCCESS, () => {
            dispatch(getOrganizationBillingInfoAsync());
            loadEmpowermentV2();
        })

        const onExecutorDeclineEmpowermentV2SuccessHandler = EventBus.on(EXECUTOR_DECLINE_EMPOWERMENT_V2_SUCCESS, () => {
            loadEmpowermentV2();
        })

        const onSyncEmpowermentV2SuccessHandler = EventBus.on(SYNC_EMPOWERMENT_V2_SUCCESS, () => {
            loadEmpowermentV2();
        })

        return () => {
            EventBus.remove(CUSTOMER_CANCEL_EMPOWERMENT_V2_SUCCESS, onCustomerCancelEmpowermentV2SuccessHandler);
            EventBus.remove(PERSON_ACCEPT_EMPOWERMENT_V2_SUCCESS, onPersonAcceptEmpowermentV2SuccessHandler);
            EventBus.remove(PERSON_DECLINE_EMPOWERMENT_V2_SUCCESS, onPersonDeclineEmpowermentV2SuccessHandler);
            EventBus.remove(EXECUTOR_ACCEPT_EMPOWERMENT_V2_SUCCESS, onExecutorAcceptEmpowermentV2SuccessHandler);
            EventBus.remove(EXECUTOR_DECLINE_EMPOWERMENT_V2_SUCCESS, onExecutorDeclineEmpowermentV2SuccessHandler);
            EventBus.remove(SYNC_EMPOWERMENT_V2_SUCCESS, onSyncEmpowermentV2SuccessHandler);
        }
    }, [])

    return (
        <>
            {empowermentV2 && <EmpowermentV2 modalId={modalId} empowermentV2={empowermentV2}/>}
            {!empowermentV2 && <SpinnerComponent />}
        </>
    )
};

export default ViewEmpowermentV2;
